export class DisplayStrings {

  public static readonly PRODUCT_ALREADY_SELECTED_MESSAGE = 'The product has already been selected';
  public static readonly DISCOUNT_MESSAGE = 'Days, Percentage and Start Date are required fields';
  public static readonly CASE_MANAGEMENT_FEATURE_DISABLED = 'The case management feature is disabled';
  public static readonly PAYMENT_FEATURE_DISABLED = 'The payment feature is disabled';
  public static readonly INFO_TOOLTIP_IMPORTED_COLUMN = 'If the status is true, then the record has been imported and is available throughout the Greydom system. If the status is false, then either the record was rejected due to validation errors, or it\'s been overwritten by a later record.';
  static idErrorMessagesList = {
    idNumberNumeric: 'ID can only contain numbers',
    idNumberLength: 'ID has to be 13 digits',
    idNumberDOB: 'Date of birth in the leading 6 digits is invalid',
    idNumberLuhn: 'This is not a valid South African ID Number',
    required: 'Please enter a valid South African Id Number',
    idExists: 'This ID number already exists'
  };
  static passportErrorMessagesList = {
    idExists: 'This Passport number already exists'
  };
  static customValidatorsList = {
    invalidNumber: 'Please enter a valid numeric value',
    invalidWholeNumber: 'Please enter a valid whole number',
    invalidMobileNumber: 'Please enter a valid mobile number',
    invalidEmail: 'Please enter a valid email address',
    atleastOneValue: 'Please enter at least one value',
  };
  static addressErrorMessagesList = {
    addressTypeError: 'Address Type already exist',
    addressMandatoryError: 'All Fields Except Address Line 2 are mandatory',
    minAddressError: 'Please Add at least 1 Address'
  };
  static contactErrorMessages = {
    contactMandatoryError: 'All Fields Except Middle Name are mandatory',
    landlinePatternError: 'landline number is not valid',
    landlineMinLengthError: 'Only 10 digits are allowed in landline number',
    mobilePatternError: 'Mobile number is not valid ',
    mobileMinLengthError: 'Only 10 digits are allowed in mobile number',
    minContactError: 'Please Add at least 1 Contact'
  };
  static bulkApplicationErrorMessagesList = {
    excelUploadError: 'There was an error reading the Excel file - please contact an administrator for assistance',
    excelSizeTooBigError: 'Cannot upload a file with more than 1000 rows - please split it into smaller files and try again',
    excelFileMissingHeaders: 'The uploaded file appears to be missing a header row.',
    excelEmptyError: 'Cannot upload an empty file. Please try again',
    excelMultipleFileError: 'Cannot upload multiple files at the same time. Please try again',
    notExcelFileError: 'You can only upload valid Excel files. Please try again',
    fetchEmployerGroupError: 'Error fetching employer groups - please contact an administrator for assistance',
    fetchBrokerError: 'Error fetching brokers - please contact an administrator for assistance'
  };
  static bulkApplicationGlobalErrorMessagesList = {
    duplicateIdentification: 'This ID type and ID number is already present in another application',
    missingPrincipal: 'This application does not contain a principal member',
    multiplePrincipal: 'This application contains multiple principal members',
    dateValidation: 'This application contains date formats which are invalid',
    referenceDataValidation: 'This application contains reference data which is invalid'
  };
  static bulkApplicationRowWarningTooltipMessagesList = {
    duplicateIdentification: 'DUPLICATE ID',
    missingPrincipal: 'MISSING PRINCIPAL',
    multiplePrincipal: 'MULTIPLE PRINCIPALS',
    dateValidation: 'INCORRECT DATE FORMAT',
    referenceDataValidation: 'INCORRECT REFERENCE DATA',
    generalValidation: 'VALIDATION ISSUE/S'
  };
  static bulkApplicationMessagesList = {
    uploadNewExcelFileConfirmationMessage: 'Uploading a new file will overwrite the existing data. Do you wish to continue?',
    deleteApplicationConfirmationMessage: 'Are you sure you want to remove'
  };
  static statusErrorMessagesList = {
    statusMandatoryError: 'All Fields are mandatory',
    minStatusError: 'Please Add at least 1 Status History'
  };
  static searchErrorMessages = {
    numberBlank: 'Please enter a valid number to search by.',
    memberNotFoundByCardOrId: 'The number you have entered does not match any of our members.'
  };
  static permissionsErrorMessages = {
    cannotEditCase: 'You do not have permission to edit a case. Please contact an administrator for more assistance.',
    cannotEditClaim: 'You do not have permission to edit or submit a claim. Please contact an administrator for more assistance.',
    cannotEditAuthorisation: 'You do not have permission to edit or submit an authorisation. Please contact an administrator for more assistance.',
    cannotEditTransaction: 'You do not have permission to edit or submit a transaction. Please contact an administrator for more assistance.',
    cannotEditImportedTransaction: 'Only changes to the end date, quantity and amount will be updated for existing activities on imported transactions. New activities added to the transaction will be processed as usual.',
    cannotClearData: 'You do not have permission to clear data. Please contact an administrator for more assistance.',
    cannotAccessPortal: 'You do not have permission to access for portal. Please contact an administrator for more assistance.',
    rolePermissionClearData: 'Only those from the pre-authorisation and claims teams can clear data',
    rolePermissionSubmitTransaction: 'Only those from the pre-authorisation and claims teams can submit claims',
    rolePermissions: {
      roleEnterpriseManager: 'Only enterprise managers can add or edit enterprise data',
      rolEnterpriseManagerClearData: 'Only those from the enterprise managers role can clear data',
      generic: 'You do not have permissions to perform this action. Please contact an administrator for more assistance.',
    }
  };
  static permissionApplicationMessages = {
    rolePermissionReprocess: 'You do not have permission to reprocess an application. Please contact an administrator for more assistance',
    rolePermissionUpdate: 'You do not have permission to update an application. Please contact an administrator for more assistance',
    statusReprocess: 'One cannot reprocess an application that has already been sent to the administration system.',
    statusUpdate: 'One cannot update an application that has already been sent to the administration system.'
  };
  static memberOverviewDialogPermissionsErrorMessages = {
    cannotView: 'You do not have permission to view details. Please contact an administrator for more assistance.',
  };
  static generic = {
    requiredFields: 'Please add values to required fields',
    disabledButton: 'The button is disabled - contact an administrator for assistance',
    externalSystem: 'Cannot save changes to a record that is managed by another system',
    dataNotExists: 'The data you are trying to access does not exist or has been deleted.',
  };
  static branchCodeMessages = {
    branchCodeNumeric: 'Branch code must contain exactly 6 numeric digits.',
  };

  static memberDeclarationText = {
    memberConsent:
      '<ol><li>By providing my details and clicking "submit", I agree that my information will be ' +
      'transferred to Bonitas Medical Fund\'s contracted third party brokers and marketing agents, ' +
      'and that such information shall be used to contact me by email or telephone to provide me ' +
      'with further information and to otherwise facilitate such transaction as may eventuate.</li></ol>',

    brokerConsent:
      '<ol><li>The broker (my FSCA licensed and accredited advisor) assigned to this application, may ' +
      'have access to my personal and medical information as well as that of my registered dependant/s.' +
      '</li>' +
      '<li>The assigned broker may instruct Bonitas to change any of my personal information ' +
      'and that of my dependant/s on their systems, except for my banking details.</li></ol>',

    brokerDeclaration:
      '<ol><li>I, the advisor/broker, confirm that the information captured on this form is true and ' +
      'correct, as provided by the member/applicant.' +
      '</li>' +
      '<li>I, the advisor/broker, acknowledge that medical conditions not disclosed may result in ' +
      'non declarations.</li></ol>',

    termsAndConditions:
      'Please ensure to read through all the Terms and Conditions at ' +
      '<a href="https://www.bonitas.co.za" target="_blank">www.bonitas.co.za</a>.',

    appointedBroker:
      '<ol class="m0"><li>The applicant has appointed me as his/her broker and is entitled to cancel my services at any time.' +
      '</li>' +
      '<li>I have signed a valid contract with my Bonitas contracted brokerage.' +
      '</li>' +
      '<li>The broker/brokerage indemnifies Bonitas against any non-adherence to the legal ' +
      'requirements as stated above.</li></ol>',

    memberDeclaration:
      'In the case of a dispute, the registered Rules of Bonitas will apply, subject to approval ' +
      'by the Registrar of Medical Schemes.',

    elusiveOffers:
      'I agree that Bonitas, Medscheme and its Contracted Third Parties may contact and provide ' +
      'Me and My Dependants with information about insurance, lifestyle rewards and products ' +
      'which have been negotiated on Your behalf by Bonitas.\n\n' +
      'Your consent along with that of your ' +
      'dependants, regarding the disclosure of your personal information, is protected and governed ' +
      'by the Protection of Personal Information Act (POPIA) 4 of 2013 (which came into effect on ' +
      '1 July 2020), as well as any other applicable data protection legislation of the Republic of ' +
      'South Africa.\n\n' +
      'You have the right to inform us if you do not want to receive any automated ' +
      'direct-marketing information, and you may opt out of receiving such information at any time ' +
      'by using the unsubscribe/opt out options on the different platforms.',
  };

  static idVerificationMessages = {
    ID_VERIFICATION_GENERAL: 'Verify the ID number before moving to the next step.',
    ID_VERIFICATION_DEPENDENT: 'The ID number will be verified automatically once you\'ve finished typing.',
    PASSPORT_VERIFICATION_GENERAL: 'Verify the passport number before moving to the next step.',
    PASSPORT_VERIFICATION_DEPENDENT: 'The passport number will be verified automatically once you\'ve finished typing.',
    APPLICATION_VERIFICATION_VALID: 'An application for the member does not exist yet. You may proceed with the application.',
    APPLICATION_VERIFICATION_INVALID: (id: string, date: string, days: number) =>
      `An accepted application (ID ${id}) captured in the last ${days} days (${date}) already exists.`,
    APPLICATION_VERIFICATION_EXISTING_BUT_ALLOWED: (id: string, date: string, days: number) =>
      `An accepted application (ID ${id}) from ${date} exists, but it's older than ${days} days so you may proceed with the application.`,
    APPLICATION_VERIFICATION_FAILED: 'The verification against existing applications failed. Please reach out to the administrator for support.',
    PASSPORT_VERIFICATION_GOVERNMENT: 'Passport numbers cannot be verified with the government authority, so this application will be pended for review once submitted.',
    ID_VERIFICATION_GOVERNMENT_VALID: 'The ID is valid in the government authority\'s system.',
    ID_VERIFICATION_GOVERNMENT_DEAD: 'The person is marked as deceased, thus the application will be pended for review once submitted.',
    ID_VERIFICATION_GOVERNMENT_INVALID: 'The ID either doesn\'t exist in the government\'s system or the system is temporarily down. The application will be pended for review after submission.',
    ID_VERIFICATION_GOVERNMENT_FAILED: 'The ID verification against the government authority failed. The application will be pended for review once submitted.',
    GENERAL_VERIFICATION_FAILED: 'An error occurred during verification. Please reach out to the administrator for support.',
  };

}
